import { createAction, props } from '@ngrx/store';
import { IDeleteBenchmarkRequest } from '../models/benckmark.model';

export const loadDeleteBenchmarkProductSolutions = createAction(
  '[DeleteBenchmarkProductSolution] Load DeleteBenchmarkProductSolutions',
  props<{ request: IDeleteBenchmarkRequest }>()
);

export const loadDeleteBenchmarkProductSolutionsSuccess = createAction(
  '[DeleteBenchmarkProductSolution] Load DeleteBenchmarkProductSolutions Success',
  props<{ response: string }>()
);

export const loadDeleteBenchmarkProductSolutionsFailure = createAction(
  '[DeleteBenchmarkProductSolution] Load DeleteBenchmarkProductSolutions Failure',
  props<{ error: any }>()
);
